"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { useRouter } from "next/navigation";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import gimirLogo from "@/assets/gimir_logo.png";
import { ForgotPasswordForm } from "./ForgotPasswordForm";
import { LoginBackground } from "./LoginBackground";
import { LoginForm } from "./LoginForm";
const HOME_PATH = "/";
export const LoginPage = () => {
  const $ = _c(19);
  const {
    t
  } = useTranslation("auth");
  const router = useRouter();
  const [isForgotPasswordVisible, setIsForgotPasswordVisible] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <LoginBackground />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("login.logoAlt");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="mx-auto mb-5 mt-[60px] flex justify-center p-[15px]"><Image src={gimirLogo} alt={t1} priority={true} /></div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== router) {
    t3 = () => router.replace(HOME_PATH);
    $[5] = router;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsForgotPasswordVisible(_temp);
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3) {
    t5 = <LoginForm onLoggedIn={t3} onForgotPassword={t4} />;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = !isForgotPasswordVisible;
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ForgotPasswordForm />;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t6) {
    t8 = <div hidden={t6}>{t7}</div>;
    $[11] = t6;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t5 || $[14] !== t8) {
    t9 = <div className="mx-auto w-full max-w-[360px] rounded-[7px] bg-white/20 px-[30px] pb-[5px] pt-5">{t5}{t8}</div>;
    $[13] = t5;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t2 || $[17] !== t9) {
    t10 = <main className="relative min-h-screen px-4 pb-10 text-sm">{t0}{t2}{t9}</main>;
    $[16] = t2;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
};
function _temp(isVisible) {
  return !isVisible;
}